import axios from "axios";

const api = axios.create({
    baseURL: process.env.REACT_APP_STGBACKEND_URL,
    timeout: 30000, // stop waiting after 30 seconds so forms never hang
    headers: {
        "Content-Type": "application/json",
    },
});
const api1 = axios.create({
    baseURL: process.env.REACT_APP_STGLM_URL,
    timeout: 30000, // stop waiting after 30 seconds so forms never hang
    headers: {
        "Content-Type": "application/json",
    },
});
export { api, api1 };
